import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as sitesApi from "./api";

const KEY = "sites";

export function useSites(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: [KEY],
    queryFn: sitesApi.listSites,
    enabled: options.enabled ?? true,
  });
}

function useInvalidate() {
  const qc = useQueryClient();
  return () => {
    void qc.invalidateQueries({ queryKey: [KEY] });
    // Customer rows show their site name; refresh those too.
    void qc.invalidateQueries({ queryKey: ["customers"] });
  };
}

export function useCreateSite() {
  const invalidate = useInvalidate();
  return useMutation({ mutationFn: sitesApi.createSite, onSuccess: invalidate });
}

export function useUpdateSite() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Parameters<typeof sitesApi.updateSite>[1] }) =>
      sitesApi.updateSite(id, body),
    onSuccess: invalidate,
  });
}

export function useDeleteSite() {
  const invalidate = useInvalidate();
  return useMutation({ mutationFn: sitesApi.deleteSite, onSuccess: invalidate });
}
